<template>
  <a-modal
    :visible="visible"
    width="702px"
    :mask-closable="false"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #team_name>
        <a-input
          v-decorator="[
            'team_name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入团队名称',
                },
              ],
            },
          ]"
          placeholder="请输入团队名称"
        />
      </template>
      <template #key_no>
        <a-select
          v-decorator="[
            'key_no',
            { rules: [{ required: true, message: '请选择关联企业' }] },
          ]"
          placeholder="请选择关联企业"
        >
          <a-select-option
            v-for="item in companyData"
            :key="item.companyInfo.qichacha_key_no"
            :value="item.companyInfo.qichacha_key_no"
          >
            {{ item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </template>
      <template #icon>
        <a-upload
          v-decorator="[
            'icon',
            {
              initialValue: [],
              rules: [{ required: true, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg,.png,.jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}system/upload`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('icon').length === 1 && $refs.basicForm.form.getFieldValue('icon')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('icon')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #desc>
        <a-textarea
          v-decorator="[
            'desc',
            { rules: [{ required: false }] },
          ]"
          rows="3"
          placeholder="请输入描述信息"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['visible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData,
      companyData: [],
      loading: false,
    };
  },
  async mounted() {
    this.changeCompanytype();
  },
  methods: {

    async changeCompanytype(){
      let url='/company/getCompanyList';
      let result = await this.$http.post(
        url,
        {page: 0, pageSize: 0}
      );
      if(result.data.status===1){
        let data=result.data.data.data_list.filter((item)=>item.status===1);

        data.forEach(element => {
          !this.companyData.includes(element.companyInfo.id)&&this.companyData.push(element);
        });

        // data.reduce((pre, cur)=>{
        //   !this.companyData.includes(pre.companyInfo.id)&&this.companyData.push(pre);
        //   return cur;
        // });
      }
    },
    normFile(e) {
      console.log('TCL: normFile -> e', e);
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if(e && e.file.status === 'done'){
        const fileList = [{
          uid: e.file.response.data.id,
          status: 'done',
          name: 'img',
          url: e.file.response.data.url,
        }];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
